import { endpoints } from "@app/api/apis";
import ROUTE from "@app/navigationApp/routes";
import Button from "@app/sharedComponents/Button/Button";
import { useAppSelector } from "@app/store/hooks";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { WarningCircle } from '@sharedComponents/Icons/Icons';
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Dimensions, Platform, ScrollView } from "react-native";
const windowWidth = Dimensions?.get('window').width -32;

const routes = {
    PRINCIPAL_REPAYMENT: ROUTE.FLEXI_PAY,
    IN_APP_INTEREST_COLLECTION: ROUTE.INTEREST_PAYMENT,
    SHORTFALL_REPAYMENT: ROUTE.SHORTFALL_REPAY,
    FORECLOSURE:ROUTE.HOW_TO_CLOSE_ACCOUNT
}

const CarouselActionCards = ({navigation }) => {
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const [failedRequestDetails, setFailedRequestDetails] = useState({});
    
    const fetchFailedRequests = () =>{
        const url = endpoints.failedRequests + userDetails?.linkedCredits[0]?.creditId       
        axios.get(url).then((res)=>{
          setFailedRequestDetails(res?.data)
        }).catch((err)=>{
          console.log('fetchFailedRequests',err);
        })
      }

    useEffect(()=>{
    if(userDetails?.linkedApplications[0]?.accountId && userDetails?.linkedCredits[0]?.creditId ){
        fetchFailedRequests()
    }
    },[userDetails])
    const { collectionDetailsList, disbursalDetailsList } = failedRequestDetails || {};
    const totalCards = (collectionDetailsList?.length || 0) + (disbursalDetailsList?.length || 0);

    const cardwidth = totalCards === 1 ? Platform.select({native:windowWidth,web:'100%'})  : Platform.select({native:windowWidth-60,web:'75%'});
    const renderCollectionFailedCard = (collectionDetails,index) => (
         <ThemedView
            backgroundColor="bg-fill-primary"
            borderRadius="sm"
            p="sm"
            width={cardwidth}
            borderWidth={1}
            borderColor="border-primary"
            mr="sm"
             flexDirection="row" alignItems="center" 
        >
                    <ThemedView flexDirection="row" alignItems="center" mr="lg" flex={3}>
                        <WarningCircle weight="fill" size={24} color={themeColorSet["icon-error"]} />
                        <ThemedView ml="sm">
                            <ThemedText variant="b4s" color="text-primary">Repayment failed</ThemedText>
                            <ThemedText variant="b5r" color="text-secondary">₹{formatIndianCurrency(collectionDetails?.actualAmountCollected)} • {dayjs(collectionDetails?.createdOn).format('DD MMM, hh:mm A')}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection="row"  alignItems="center" justifyContent="flex-end" flex={1} >
                        <Button type="TEXT" size="SM" label="Details" handlePress={() => navigation.navigate(ROUTE.TRANSACTION_SCREEN,{transactionId:collectionDetails?.collectionId})} overRideTextStyle={{marginHorizontal:0}}/>
                        <Button type="OUTLINED" size="SM" label="Retry" handlePress={()=>navigation.navigate(routes[collectionDetails?.collectionType],{paymentAmount:collectionDetails?.actualAmountCollected})} overRideTextStyle={{marginHorizontal:0}} overRideStyle={{marginLeft:8}}  />
                    </ThemedView>
        </ThemedView>
    );

    const renderDisbursalFailedCard = (disbursalDetail, index) => (
        <ThemedView
            backgroundColor="bg-fill-primary"
            borderRadius="sm"
            p="sm"
            width={cardwidth}
            borderWidth={1}
            borderColor="border-primary"
            mr="sm"
            flexDirection="row" alignItems="center" 
        >
                    <ThemedView flexDirection="row" alignItems="center" mr="lg" flex={3}>
                        <WarningCircle weight="fill" size={24} color={themeColorSet["icon-error"]} />
                        <ThemedView ml="sm">
                            <ThemedText variant="b4s" color="text-primary">Withdrawal failed</ThemedText>
                            <ThemedText variant="b5r" color="text-secondary">₹{formatIndianCurrency(disbursalDetail?.amount)} • {dayjs(disbursalDetail?.createdOn).format('DD MMM, hh:mm A')}</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection="row"  alignItems="center" justifyContent="flex-end" flex={1}>
                        <Button type="TEXT" size="SM" label="Details" handlePress={() => navigation.navigate(ROUTE.TRANSACTION_SCREEN)} overRideTextStyle={{marginHorizontal:0}} />
                        <Button type="OUTLINED" size="SM" label="Retry" handlePress={()=>{navigation.navigate(ROUTE.WITHDRAW_AMOUNT,{amount:disbursalDetail?.amount})}} overRideTextStyle={{marginHorizontal:0}} overRideStyle={{marginLeft:8}} />
                    </ThemedView>
        </ThemedView>
    );
    if(totalCards===0) return null;
    return (
        <>
            <ThemedView mt="lg" ml="lg" mr="sm" flex={1}>
                {totalCards > 1 ? (
                    <ScrollView  
                        horizontal showsHorizontalScrollIndicator={false}
                        contentContainerStyle={{ flexDirection: 'row', alignItems: 'stretch', flexGrow: 1 }}
                    >
                        {collectionDetailsList?.length > 0 && collectionDetailsList?.map(renderCollectionFailedCard)}
                        {disbursalDetailsList?.length > 0 && disbursalDetailsList?.map(renderDisbursalFailedCard)}
                    </ScrollView>
                ) : (
                    <ThemedView flex={1}>
                        {collectionDetailsList?.length > 0 && collectionDetailsList?.map(renderCollectionFailedCard)}
                        {disbursalDetailsList?.length > 0 && disbursalDetailsList.map(renderDisbursalFailedCard)}
                    </ThemedView>
                )}
            </ThemedView>
        </>
    );
};

export default CarouselActionCards;